module.exports = __webpack_public_path__ + "img/instagram2.316972ac.png";